// extracted by mini-css-extract-plugin
export var infoRow = "_t0-2";
export var labelContainer = "_t0-0";
export var rightInfo = "_t0-1";